export class PackageRegistrationToken {
  static IPackageRegistrationRepository = Symbol(
    "IPackageRegistrationRepository",
  );
  static PackageRegistrationViewModel = Symbol("PackageRegistrationViewModel");
  static PackageRegistrationUseCase = Symbol("PackageRegistrationUseCase");
}
